<body>
    <div class="privacy_policy_container" id="privacyTop">
        <div class="content">
            <h1>Datenschutzerklärung</h1>
            <br id="m716">
            <br>
            <br>
            <br>
            <h2>Präambel</h2>
            <p>Mit der folgenden Datenschutzerklärung möchten wir Sie darüber aufklären, welche Arten Ihrer
                personenbezogenen
                Daten (nachfolgend auch kurz als "Daten" bezeichnet) wir zu welchen Zwecken und in welchem Umfang
                verarbeiten.
                Die Datenschutzerklärung gilt für alle von uns durchgeführten Verarbeitungen personenbezogener Daten,
                sowohl im
                Rahmen der Erbringung unserer Leistungen als auch insbesondere auf unseren Webseiten, in mobilen
                Applikationen
                sowie innerhalb externer Onlinepräsenzen, wie z. B. unserer Social-Media-Profile (nachfolgend
                zusammenfassend
                bezeichnet als "Onlineangebot").</p>
            <p>Die verwendeten Begriffe sind nicht geschlechtsspezifisch.</p>

            <p>Stand: 27. Dezember 2024</p>
            <h2>Inhaltsübersicht</h2>
            <ul class="index">
                <li><a class="index-link" (click)="goToParagraph('#m716')">Präambel</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m3')">Verantwortlicher</a></li>
                <li><a class="index-link" (click)="goToParagraph('#mOverview')">Übersicht der Verarbeitungen</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m2427')">Maßgebliche Rechtsgrundlagen</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m27')">Sicherheitsmaßnahmen</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m10')">Rechte der betroffenen Personen</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m225')">Bereitstellung des Onlineangebots und
                        Webhosting</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m367')">Registrierung, Anmeldung und Nutzerkonto</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m182')">Kontakt- und Anfrageverwaltung</a></li>
                <li><a class="index-link" (click)="goToParagraph('#m42')">Begriffsdefinitionen</a></li>
            </ul>
            <br id="m3">
            <br>
            <br>
            <br>
            <h2>Verantwortlicher</h2>
            <p>Sangeethan Logananthem<br>Beim Fasanengarten 37<br>70499 Stuttgart</p>
            <p>E-Mail-Adresse: contact&#64;sangeethan-developer.com</p>

            <br id="mOverview">
            <br>
            <br>
            <br>
            <h2>Übersicht der Verarbeitungen</h2>
            <p>Die nachfolgende Übersicht fasst die Arten der verarbeiteten Daten und die Zwecke ihrer Verarbeitung
                zusammen und
                verweist auf die betroffenen Personen.</p>
            <h3>Arten der verarbeiteten Daten</h3>
            <ul>
                <li>Bestandsdaten.</li>
                <li>Kontaktdaten.</li>
                <li>Inhaltsdaten.</li>
                <li>Nutzungsdaten.</li>
                <li>Meta-, Kommunikations- und Verfahrensdaten.</li>
                <li>Protokolldaten.</li>
            </ul>
            <h3>Kategorien betroffener Personen</h3>
            <ul>
                <li>Kommunikationspartner.</li>
                <li>Nutzer.</li>
            </ul>
            <h3>Zwecke der Verarbeitung</h3>
            <ul>
                <li>Erbringung vertraglicher Leistungen und Erfüllung vertraglicher Pflichten.</li>
                <li>Kommunikation.</li>
                <li>Sicherheitsmaßnahmen.</li>
                <li>Organisations- und Verwaltungsverfahren.</li>
                <li>Feedback.</li>
                <li>Bereitstellung unseres Onlineangebotes und Nutzerfreundlichkeit.</li>
                <li>Informationstechnische Infrastruktur.</li>
            </ul>
            <br id="m2427">
            <br>
            <br>
            <br>
            <h2>Maßgebliche Rechtsgrundlagen</h2>
            <p><strong>Maßgebliche Rechtsgrundlagen nach der DSGVO: </strong>Im Folgenden erhalten Sie eine Übersicht
                der
                Rechtsgrundlagen der DSGVO, auf deren Basis wir personenbezogene Daten verarbeiten. Bitte nehmen Sie zur
                Kenntnis, dass neben den Regelungen der DSGVO nationale Datenschutzvorgaben in Ihrem bzw. unserem Wohn-
                oder
                Sitzland gelten können. Sollten ferner im Einzelfall speziellere Rechtsgrundlagen maßgeblich sein,
                teilen wir
                Ihnen diese in der Datenschutzerklärung mit.</p>
            <ul>
                <li><strong>Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO)</strong> -
                    Die
                    Verarbeitung ist für die Erfüllung eines Vertrags, dessen Vertragspartei die betroffene Person ist,
                    oder zur
                    Durchführung vorvertraglicher Maßnahmen erforderlich, die auf Anfrage der betroffenen Person
                    erfolgen.</li>
                <li><strong>Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO)</strong> - die Verarbeitung ist
                    zur
                    Wahrung der berechtigten Interessen des Verantwortlichen oder eines Dritten notwendig,
                    vorausgesetzt, dass
                    die Interessen, Grundrechte und Grundfreiheiten der betroffenen Person, die den Schutz
                    personenbezogener
                    Daten verlangen, nicht überwiegen.</li>
            </ul>
            <p><strong>Nationale Datenschutzregelungen in Deutschland: </strong>Zusätzlich zu den Datenschutzregelungen
                der
                DSGVO gelten nationale Regelungen zum Datenschutz in Deutschland. Hierzu gehört insbesondere das Gesetz
                zum
                Schutz vor Missbrauch personenbezogener Daten bei der Datenverarbeitung (Bundesdatenschutzgesetz –
                BDSG). Das
                BDSG enthält insbesondere Spezialregelungen zum Recht auf Auskunft, zum Recht auf Löschung, zum
                Widerspruchsrecht, zur Verarbeitung besonderer Kategorien personenbezogener Daten, zur Verarbeitung für
                andere
                Zwecke und zur Übermittlung sowie automatisierten Entscheidungsfindung im Einzelfall einschließlich
                Profiling.
                Ferner können Landesdatenschutzgesetze der einzelnen Bundesländer zur Anwendung gelangen.</p>

            <br id="m27">
            <br>
            <br>
            <br>
            <h2>Sicherheitsmaßnahmen</h2>
            <p>Wir treffen nach Maßgabe der gesetzlichen Vorgaben unter Berücksichtigung des Stands der Technik, der
                Implementierungskosten und der Art, des Umfangs, der Umstände und der Zwecke der Verarbeitung sowie der
                unterschiedlichen Eintrittswahrscheinlichkeiten und des Ausmaßes der Bedrohung der Rechte und Freiheiten
                natürlicher Personen geeignete technische und organisatorische Maßnahmen, um ein dem Risiko angemessenes
                Schutzniveau zu gewährleisten.</p>
            <p>Zu den Maßnahmen gehören insbesondere die Sicherung der Vertraulichkeit, Integrität und Verfügbarkeit von
                Daten
                durch Kontrolle des physischen und elektronischen Zugangs zu den Daten als auch des sie betreffenden
                Zugriffs,
                der Eingabe, der Weitergabe, der Sicherung der Verfügbarkeit und ihrer Trennung. Des Weiteren haben wir
                Verfahren eingerichtet, die eine Wahrnehmung von Betroffenenrechten, die Löschung von Daten und
                Reaktionen auf
                die Gefährdung der Daten gewährleisten. Ferner berücksichtigen wir den Schutz personenbezogener Daten
                bereits
                bei der Entwicklung bzw. Auswahl von Hardware, Software sowie Verfahren entsprechend dem Prinzip des
                Datenschutzes, durch Technikgestaltung und durch datenschutzfreundliche Voreinstellungen.</p>
            <p>Sicherung von Online-Verbindungen durch TLS-/SSL-Verschlüsselungstechnologie (HTTPS): Um die Daten der
                Nutzer,
                die über unsere Online-Dienste übertragen werden, vor unerlaubten Zugriffen zu schützen, setzen wir auf
                die
                TLS-/SSL-Verschlüsselungstechnologie. Secure Sockets Layer (SSL) und Transport Layer Security (TLS) sind
                die
                Eckpfeiler der sicheren Datenübertragung im Internet. Diese Technologien verschlüsseln die
                Informationen, die
                zwischen der Website oder App und dem Browser des Nutzers (oder zwischen zwei Servern) übertragen
                werden,
                wodurch die Daten vor unbefugtem Zugriff geschützt sind. TLS, als die weiterentwickelte und sicherere
                Version
                von SSL, gewährleistet, dass alle Datenübertragungen den höchsten Sicherheitsstandards entsprechen. Wenn
                eine
                Website durch ein SSL-/TLS-Zertifikat gesichert ist, wird dies durch die Anzeige von HTTPS in der URL
                signalisiert. Dies dient als ein Indikator für die Nutzer, dass ihre Daten sicher und verschlüsselt
                übertragen
                werden.</p>
            <br id="m10">
            <br>
            <br>
            <br>
            <h2>Rechte der betroffenen Personen</h2>
            <p>Rechte der betroffenen Personen aus der DSGVO: Ihnen stehen als Betroffene nach der DSGVO verschiedene
                Rechte zu,
                die sich insbesondere aus Art. 15 bis 21 DSGVO ergeben:</p>
            <ul>
                <li><strong>Widerspruchsrecht: Sie haben das Recht, aus Gründen, die sich aus Ihrer besonderen Situation
                        ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die
                        aufgrund von
                        Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf
                        diese
                        Bestimmungen gestütztes Profiling. Werden die Sie betreffenden personenbezogenen Daten
                        verarbeitet, um
                        Direktwerbung zu betreiben, haben Sie das Recht, jederzeit Widerspruch gegen die Verarbeitung
                        der Sie
                        betreffenden personenbezogenen Daten zum Zwecke derartiger Werbung einzulegen; dies gilt auch
                        für das
                        Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.</strong></li>
                <li><strong>Widerrufsrecht bei Einwilligungen:</strong> Sie haben das Recht, erteilte Einwilligungen
                    jederzeit
                    zu widerrufen.</li>
                <li><strong>Auskunftsrecht:</strong> Sie haben das Recht, eine Bestätigung darüber zu verlangen, ob
                    betreffende
                    Daten verarbeitet werden und auf Auskunft über diese Daten sowie auf weitere Informationen und Kopie
                    der
                    Daten entsprechend den gesetzlichen Vorgaben.</li>
                <li><strong>Recht auf Berichtigung:</strong> Sie haben entsprechend den gesetzlichen Vorgaben das Recht,
                    die
                    Vervollständigung der Sie betreffenden Daten oder die Berichtigung der Sie betreffenden unrichtigen
                    Daten zu
                    verlangen.</li>
                <li><strong>Recht auf Löschung und Einschränkung der Verarbeitung:</strong> Sie haben nach Maßgabe der
                    gesetzlichen Vorgaben das Recht, zu verlangen, dass Sie betreffende Daten unverzüglich gelöscht
                    werden, bzw.
                    alternativ nach Maßgabe der gesetzlichen Vorgaben eine Einschränkung der Verarbeitung der Daten zu
                    verlangen.</li>
                <li><strong>Recht auf Datenübertragbarkeit:</strong> Sie haben das Recht, Sie betreffende Daten, die Sie
                    uns
                    bereitgestellt haben, nach Maßgabe der gesetzlichen Vorgaben in einem strukturierten, gängigen und
                    maschinenlesbaren Format zu erhalten oder deren Übermittlung an einen anderen Verantwortlichen zu
                    fordern.
                </li>
                <li><strong>Beschwerde bei Aufsichtsbehörde:</strong> Sie haben unbeschadet eines anderweitigen
                    verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs das Recht auf Beschwerde bei einer
                    Aufsichtsbehörde,
                    insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthaltsorts, ihres Arbeitsplatzes oder des
                    Orts des
                    mutmaßlichen Verstoßes, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden
                    personenbezogenen Daten gegen die Vorgaben der DSGVO verstößt.</li>
            </ul>
            <br id="m225">
            <br>
            <br>
            <br>
            <h2>Bereitstellung des Onlineangebots und Webhosting</h2>
            <p>Wir verarbeiten die Daten der Nutzer, um ihnen unsere Online-Dienste zur Verfügung stellen zu können. Zu
                diesem
                Zweck verarbeiten wir die IP-Adresse des Nutzers, die notwendig ist, um die Inhalte und Funktionen
                unserer
                Online-Dienste an den Browser oder das Endgerät der Nutzer zu übermitteln.</p>
            <ul class="m-elements">
                <li><strong>Verarbeitete Datenarten:</strong> Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer,
                    Klickpfade,
                    Nutzungsintensität und -frequenz, verwendete Gerätetypen und Betriebssysteme, Interaktionen mit
                    Inhalten und
                    Funktionen); Meta-, Kommunikations- und Verfahrensdaten (z. B. IP-Adressen, Zeitangaben,
                    Identifikationsnummern, beteiligte Personen). Protokolldaten (z. B. Logfiles betreffend Logins oder
                    den
                    Abruf von Daten oder Zugriffszeiten.).</li>
                <li><strong>Betroffene Personen:</strong> Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).
                </li>
                <li><strong>Zwecke der Verarbeitung:</strong> Bereitstellung unseres Onlineangebotes und
                    Nutzerfreundlichkeit.
                    Informationstechnische Infrastruktur (Betrieb und Bereitstellung von Informationssystemen und
                    technischen
                    Geräten (Computer, Server etc.).).</li>
                <li><strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend Angaben im Abschnitt "Allgemeine
                    Informationen zur Datenspeicherung und Löschung".</li>
                <li class=""><strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
                    DSGVO).</li>
            </ul>
            <p><strong>Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</strong></p>
            <ul class="m-elements">
                <li><strong>Bereitstellung Onlineangebot auf gemietetem Speicherplatz: </strong>Für die Bereitstellung
                    unseres
                    Onlineangebotes nutzen wir Speicherplatz, Rechenkapazität und Software, die wir von einem
                    entsprechenden
                    Serveranbieter (auch "Webhoster" genannt) mieten oder anderweitig beziehen; <span
                        class=""><strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
                        DSGVO).</span></li>
                <li><strong>ALL-INKL: </strong>Leistungen auf dem Gebiet der Bereitstellung von informationstechnischer
                    Infrastruktur und verbundenen Dienstleistungen (z. B. Speicherplatz und/oder Rechenkapazitäten);
                    <strong>Dienstanbieter:</strong> ALL-INKL.COM - Neue Medien Münnich, Inhaber: René Münnich,
                    Hauptstraße 68,
                    02742 Friedersdorf, Deutschland; <span class=""><strong>Rechtsgrundlagen:</strong> Berechtigte
                        Interessen
                        (Art. 6 Abs. 1 S. 1 lit. f) DSGVO); </span><strong>Website:</strong> <a
                        href="https://all-inkl.com/" target="_blank">https://all-inkl.com/</a>;
                    <strong>Datenschutzerklärung:</strong> <a href="https://all-inkl.com/datenschutzinformationen/"
                        target="_blank">https://all-inkl.com/datenschutzinformationen/</a>.
                    <strong>Auftragsverarbeitungsvertrag:</strong> Wird vom Dienstanbieter bereitgestellt.
                </li>
            </ul>
            <br id="m367">
            <br>
            <br>
            <br>
            <h2>Registrierung, Anmeldung und Nutzerkonto</h2>
            <p>Nutzer können ein Nutzerkonto anlegen. Zu den Nutzerdaten gehören insbesondere die Login-Informationen
                (Nutzername, Passwort sowie eine E-Mail-Adresse).</p>
            <p>Die Nutzer können über Vorgänge, die für deren Nutzerkonto relevant sind, wie z. B. technische
                Änderungen, per
                E-Mail informiert werden.</p>
            <ul class="m-elements">
                <li><strong>Verarbeitete Datenarten:</strong> Bestandsdaten (z. B. der vollständige Name, Wohnadresse,
                    Kontaktinformationen, Kundennummer, etc.); Kontaktdaten (z. B. Post- und E-Mail-Adressen oder
                    Telefonnummern); Inhaltsdaten (z. B. textliche oder bildliche Nachrichten und Beiträge sowie die sie
                    betreffenden Informationen, wie z. B. Angaben zur Autorenschaft oder Zeitpunkt der Erstellung);
                    </li>
                <li><strong>Betroffene Personen:</strong> Nutzer (z. B. Webseitenbesucher, Nutzer von Onlinediensten).
                </li>
                <li><strong>Zwecke der Verarbeitung:</strong> Bereitstellung unseres
                    Onlineangebotes und Nutzerfreundlichkeit.</li>
                <li><strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend Angaben im Abschnitt "Allgemeine
                    Informationen zur Datenspeicherung und Löschung". Löschung nach Kündigung.</li>
                <li class=""><strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche Anfragen (Art. 6
                    Abs. 1 S.
                    1 lit. b) DSGVO). Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f) DSGVO).</li>
            </ul>
            <p><strong>Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</strong></p>
            <ul class="m-elements">
                <li><strong>Registrierung mit Pseudonymen: </strong>Nutzer dürfen statt Klarnamen Pseudonyme als
                    Nutzernamen
                    verwenden; <span class=""><strong>Rechtsgrundlagen:</strong> Vertragserfüllung und vorvertragliche
                        Anfragen
                        (Art. 6 Abs. 1 S. 1 lit. b) DSGVO).</span></li>
                <li><strong>Profile der Nutzer sind nicht öffentlich: </strong>Die Profile der Nutzer sind öffentlich
                    nicht
                    sichtbar und nicht zugänglich.</li>
            </ul>
            <br id="m182">
            <br>
            <br>
            <br>
            <h2>Kontakt- und Anfrageverwaltung</h2>
            <p>Bei der Kontaktaufnahme mit uns (z. B. per Post, Kontaktformular, E-Mail, Telefon oder via soziale
                Medien) sowie
                im Rahmen bestehender Nutzer- und Geschäftsbeziehungen werden die Angaben der anfragenden Personen
                verarbeitet,
                soweit dies zur Beantwortung der Kontaktanfragen und etwaiger angefragter Maßnahmen erforderlich ist.
            </p>
            <ul class="m-elements">
                <li><strong>Verarbeitete Datenarten:</strong> Bestandsdaten (z. B. der vollständige Name, Wohnadresse,
                    Kontaktinformationen, Kundennummer, etc.); Kontaktdaten (z. B. Post- und E-Mail-Adressen oder
                    Telefonnummern); Inhaltsdaten (z. B. textliche oder bildliche Nachrichten und Beiträge sowie die sie
                    betreffenden Informationen, wie z. B. Angaben zur Autorenschaft oder Zeitpunkt der Erstellung);
                    Nutzungsdaten (z. B. Seitenaufrufe und Verweildauer, Klickpfade, Nutzungsintensität und -frequenz,
                    verwendete Gerätetypen und Betriebssysteme, Interaktionen mit Inhalten und Funktionen). Meta-,
                    Kommunikations- und Verfahrensdaten (z. B. IP-Adressen, Zeitangaben, Identifikationsnummern,
                    beteiligte
                    Personen).</li>
                <li><strong>Betroffene Personen:</strong> Kommunikationspartner.</li>
                <li><strong>Zwecke der Verarbeitung:</strong> Kommunikation; Organisations- und Verwaltungsverfahren;
                    Feedback
                    (z. B. Sammeln von Feedback via Online-Formular). Bereitstellung unseres Onlineangebotes und
                    Nutzerfreundlichkeit.</li>
                <li><strong>Aufbewahrung und Löschung:</strong> Löschung entsprechend Angaben im Abschnitt "Allgemeine
                    Informationen zur Datenspeicherung und Löschung".</li>
                <li class=""><strong>Rechtsgrundlagen:</strong> Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
                    DSGVO).
                    Vertragserfüllung und vorvertragliche Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO).</li>
            </ul>
            <p><strong>Weitere Hinweise zu Verarbeitungsprozessen, Verfahren und Diensten:</strong></p>
            <ul class="m-elements">
                <li><strong>Kontaktformular: </strong>Bei Kontaktaufnahme über unser Kontaktformular, per E-Mail oder
                    anderen
                    Kommunikationswegen, verarbeiten wir die uns übermittelten personenbezogenen Daten zur Beantwortung
                    und
                    Bearbeitung des jeweiligen Anliegens. Dies umfasst in der Regel Angaben wie Name,
                    Kontaktinformationen und
                    gegebenenfalls weitere Informationen, die uns mitgeteilt werden und zur angemessenen Bearbeitung
                    erforderlich sind. Wir nutzen diese Daten ausschließlich für den angegebenen Zweck der
                    Kontaktaufnahme und
                    Kommunikation; <span class=""><strong>Rechtsgrundlagen:</strong> Vertragserfüllung und
                        vorvertragliche
                        Anfragen (Art. 6 Abs. 1 S. 1 lit. b) DSGVO), Berechtigte Interessen (Art. 6 Abs. 1 S. 1 lit. f)
                        DSGVO).</span></li>
            </ul>
            <br id="m42">
            <br>
            <br>
            <br>
            <h2>Begriffsdefinitionen</h2>
            <p>In diesem Abschnitt erhalten Sie eine Übersicht über die in dieser Datenschutzerklärung verwendeten
                Begrifflichkeiten. Soweit die Begrifflichkeiten gesetzlich definiert sind, gelten deren gesetzliche
                Definitionen. Die nachfolgenden Erläuterungen sollen dagegen vor allem dem Verständnis dienen.</p>
            <ul class="glossary">
                <li><strong>Bestandsdaten:</strong> Bestandsdaten umfassen wesentliche Informationen, die für die
                    Identifikation
                    und Verwaltung von Vertragspartnern, Benutzerkonten, Profilen und ähnlichen Zuordnungen notwendig
                    sind.
                    Diese Daten können u.a. persönliche und demografische Angaben wie Namen, Kontaktinformationen
                    (Adressen,
                    Telefonnummern, E-Mail-Adressen), Geburtsdaten und spezifische Identifikatoren (Benutzer-IDs)
                    beinhalten.
                    Bestandsdaten bilden die Grundlage für jegliche formelle Interaktion zwischen Personen und Diensten,
                    Einrichtungen oder Systemen, indem sie eine eindeutige Zuordnung und Kommunikation ermöglichen.
                </li>
                <li><strong>Inhaltsdaten:</strong> Inhaltsdaten umfassen Informationen, die im Zuge der Erstellung,
                    Bearbeitung
                    und Veröffentlichung von Inhalten aller Art generiert werden. Diese Kategorie von Daten kann Texte,
                    Bilder,
                    Videos, Audiodateien und andere multimediale Inhalte einschließen, die auf verschiedenen Plattformen
                    und
                    Medien veröffentlicht werden. Inhaltsdaten sind nicht nur auf den eigentlichen Inhalt beschränkt,
                    sondern
                    beinhalten auch Metadaten, die Informationen über den Inhalt selbst liefern, wie Tags,
                    Beschreibungen,
                    Autoreninformationen und Veröffentlichungsdaten </li>
                <li><strong>Kontaktdaten:</strong> Kontaktdaten sind essentielle Informationen, die die Kommunikation
                    mit
                    Personen oder Organisationen ermöglichen. Sie umfassen u.a. Telefonnummern, postalische Adressen und
                    E-Mail-Adressen, sowie Kommunikationsmittel wie soziale Medien-Handles und
                    Instant-Messaging-Identifikatoren. </li>
                <li><strong>Meta-, Kommunikations- und Verfahrensdaten:</strong> Meta-, Kommunikations- und
                    Verfahrensdaten sind
                    Kategorien, die Informationen über die Art und Weise enthalten, wie Daten verarbeitet, übermittelt
                    und
                    verwaltet werden. Meta-Daten, auch bekannt als Daten über Daten, umfassen Informationen, die den
                    Kontext,
                    die Herkunft und die Struktur anderer Daten beschreiben. Sie können Angaben zur Dateigröße, dem
                    Erstellungsdatum, dem Autor eines Dokuments und den Änderungshistorien beinhalten.
                    Kommunikationsdaten
                    erfassen den Austausch von Informationen zwischen Nutzern über verschiedene Kanäle, wie
                    E-Mail-Verkehr,
                    Anrufprotokolle, Nachrichten in sozialen Netzwerken und Chat-Verläufe, inklusive der beteiligten
                    Personen,
                    Zeitstempel und Übertragungswege. Verfahrensdaten beschreiben die Prozesse und Abläufe innerhalb von
                    Systemen oder Organisationen, einschließlich Workflow-Dokumentationen, Protokolle von Transaktionen
                    und
                    Aktivitäten, sowie Audit-Logs, die zur Nachverfolgung und Überprüfung von Vorgängen verwendet
                    werden. </li>
                <li><strong>Nutzungsdaten:</strong> Nutzungsdaten beziehen sich auf Informationen, die erfassen, wie
                    Nutzer mit
                    digitalen Produkten, Dienstleistungen oder Plattformen interagieren. Diese Daten umfassen eine
                    breite
                    Palette von Informationen, die aufzeigen, wie Nutzer Anwendungen nutzen, welche Funktionen sie
                    bevorzugen,
                    wie lange sie auf bestimmten Seiten verweilen und über welche Pfade sie durch eine Anwendung
                    navigieren.
                    Nutzungsdaten können auch die Häufigkeit der Nutzung, Zeitstempel von Aktivitäten, IP-Adressen,
                    Geräteinformationen und Standortdaten einschließen. Sie sind besonders wertvoll für die Analyse des
                    Nutzerverhaltens, die Optimierung von Benutzererfahrungen, das Personalisieren von Inhalten und das
                    Verbessern von Produkten oder Dienstleistungen. Darüber hinaus spielen Nutzungsdaten eine
                    entscheidende
                    Rolle beim Erkennen von Trends, Vorlieben und möglichen Problembereichen innerhalb digitaler
                    Angebote </li>
                <li><strong>Personenbezogene Daten:</strong> "Personenbezogene Daten" sind alle Informationen, die sich
                    auf eine
                    identifizierte oder identifizierbare natürliche Person (im Folgenden "betroffene Person") beziehen;
                    als
                    identifizierbar wird eine natürliche Person angesehen, die direkt oder indirekt, insbesondere
                    mittels
                    Zuordnung zu einer Kennung wie einem Namen, zu einer Kennnummer, zu Standortdaten, zu einer
                    Online-Kennung
                    (z. B. Cookie) oder zu einem oder mehreren besonderen Merkmalen identifiziert werden kann, die
                    Ausdruck der
                    physischen, physiologischen, genetischen, psychischen, wirtschaftlichen, kulturellen oder sozialen
                    Identität
                    dieser natürlichen Person sind. </li>
                <li><strong>Protokolldaten:</strong> Protokolldaten sind Informationen über Ereignisse oder Aktivitäten,
                    die in
                    einem System oder Netzwerk protokolliert wurden. Diese Daten enthalten typischerweise Informationen
                    wie
                    Zeitstempel, IP-Adressen, Benutzeraktionen, Fehlermeldungen und andere Details über die Nutzung oder
                    den
                    Betrieb eines Systems. Protokolldaten werden oft zur Analyse von Systemproblemen, zur
                    Sicherheitsüberwachung
                    oder zur Erstellung von Leistungsberichten verwendet. </li>
                <li><strong>Verantwortlicher:</strong> Als "Verantwortlicher" wird die natürliche oder juristische
                    Person,
                    Behörde, Einrichtung oder andere Stelle, die allein oder gemeinsam mit anderen über die Zwecke und
                    Mittel
                    der Verarbeitung von personenbezogenen Daten entscheidet, bezeichnet. </li>
                <li><strong>Verarbeitung:</strong> "Verarbeitung" ist jeder mit oder ohne Hilfe automatisierter
                    Verfahren
                    ausgeführte Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten. Der
                    Begriff
                    reicht weit und umfasst praktisch jeden Umgang mit Daten, sei es das Erheben, das Auswerten, das
                    Speichern,
                    das Übermitteln oder das Löschen. </li>
            </ul>
            <p class="seal"><a href="https://datenschutz-generator.de/"
                    title="Rechtstext von Dr. Schwenke - für weitere Informationen bitte anklicken." target="_blank"
                    rel="noopener noreferrer nofollow">Erstellt mit kostenlosem Datenschutz-Generator.de von Dr. Thomas
                    Schwenke</a></p>
        </div>
    </div>
</body>